import URLS from '@/server/urls';
import { POST } from '@/server/http';
export default async ({
  role,
  api
}, options = {
  showError: true
}) => {
  const [content, error, status] = await POST(URLS.perms.delPerm, {
    role,
    api
  }, options);
  if (error) return {
    error,
    status
  };
  return content || {};
};